<template>
    <ValidationObserver class="needs-validation form-custom-format " v-bind:class="{'was-validated' : validated}" tag="form" ref="observer" v-slot="{passes}" @submit.prevent="onSubmitForm()">
            <el-dialog :modal="true" :fullscreen="false" :title="'GET MANIFEST'" :visible.sync="isVisible" :close-on-click-modal="false" :modal-append-to-body="true" :append-to-body="true" size="small" class="text-left manifest-dialog">
                
                <div class="p-2">
                    <ThatsInput
                                :label="'Manifest No.'"
                                :vid="'manifest-no'"
                                :name="'manifest-no'"
                                :data="[]"
                                v-model="formData.manifest_no"
                                :validated="validated"
                                :rules="''"
                                :size="'sm'"
                                :disabled="readOnly"
                            />
                </div>
                <div slot="footer" class="dialog-footer">
                    <template v-if="processing">
                        <mdb-btn color="elegant" size="sm" disabled class="btn btn-sm btn-elegant">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Please wait...
                        </mdb-btn>
                    </template>
                    <template v-else>
                        <mdb-btn color="elegant" size="sm" @click="passes(onSubmitForm)" :disabled="processing || !isManifestNoEmpty" class="btn btn-sm btn-elegant">
                            Get Manifest
                        </mdb-btn>
                        <mdb-btn color="elegant" size="sm" @click="closeDialog" :disabled="processing" class="btn btn-sm btn-elegant ml-0">
                            Close
                        </mdb-btn>
                    </template>
                </div>
            </el-dialog>
        </ValidationObserver>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import {mdbBtn,mdbRow,mdbCol} from 'mdbvue';
import  { ThatsInput} from '../../components/thats/Thats'
import { mapActions } from 'vuex'
export default {
    name: 'GetManifrestModal',

    components : {
        ValidationObserver,
        ThatsInput,
        mdbBtn,
        mdbRow,
        mdbCol
    },
    inject : ['connection'],
    data() {
        return {
            isVisible : false,
            validated : false,
            processing : false,
            readOnly : false,
            formData : {
                manifest_no : ""
            },

            lisaConnection : {
                QATL_PRODUCTION : "LISA_QATL_PRODUCTION",
                QATL_DEV : "LISA_QATL_DEV"
            }
        }
    },
    methods : {
        ...mapActions('WarehouseLabelModule',[ 'getManifest' ]),
        onSubmitForm(){

           if(this.isManifestNoEmpty){
            this.processing = true;
               this.getManifest({manifest : this.formData.manifest_no, connection : this.lisaConnection[this.computedConnection]}).then((response) => {
                   console.log("response")
                   console.log(response)
                   this.processing = false;
                   this.$emit('success',response)
                   this.closeDialog()
               }).catch((error) => {
                   console.log("error")
                   console.log(error)
                   this.processing = false;
                   this.$emit('error',error)
                   this.closeDialog()
               })
           }
        },
        openDialog(){
            this.isVisible = true;
        },
        closeDialog(){
            this.isVisible = false;
        }
    },

    computed : {
        isManifestNoEmpty(){
            return this.formData.manifest_no != "";
        },
        computedConnection() {
            return this.connection();
        }
    }
}
</script>
